import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const NAV = [
  { to: "/admin", icon: "fa-gauge-high", label: "Panel", end: true },
  { to: "/admin/categories", icon: "fa-layer-group", label: "Kategoriler" },
  { to: "/admin/products", icon: "fa-mug-saucer", label: "Ürünler" },
  { to: "/admin/service-calls", icon: "fa-bell-concierge", label: "Garson Çağrıları" },
  { to: "/admin/qr-areas", icon: "fa-qrcode", label: "QR Alanları" },
  { to: "/admin/settings", icon: "fa-gear", label: "Site Ayarları" },
  { to: "/admin/media", icon: "fa-images", label: "Görsel Galerisi" },
  { to: "/admin/users", icon: "fa-user-shield", label: "Kullanıcılar" },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-zbeach-bg">
      {/* Sidebar */}
      <aside className={`fixed lg:static z-40 inset-y-0 left-0 w-64 bg-zbeach-surface border-r border-zbeach-gold/15 transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-6 border-b border-zbeach-gold/10">
          <div className="font-serif text-2xl text-gold-gradient font-semibold tracking-wider">Z BEACH</div>
          <div className="text-xs text-zbeach-muted mt-0.5">Admin Panel</div>
        </div>
        <nav className="p-3 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to} to={item.to} end={item.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition ${isActive ? "bg-zbeach-turquoise text-white font-medium" : "text-zbeach-muted hover:bg-zbeach-bg hover:text-zbeach-dark"}`
              }
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <i className={`fa-solid ${item.icon} w-4 text-center`} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-zbeach-gold/10">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-zbeach-gold/20 flex items-center justify-center text-zbeach-gold font-semibold">{user?.name?.[0] || "A"}</div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium text-zbeach-dark truncate">{user?.email}</div>
              <button onClick={logout} className="text-[11px] text-zbeach-muted hover:text-zbeach-dark" data-testid="logout-btn">Çıkış yap</button>
            </div>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="sticky top-0 z-30 bg-zbeach-surface/85 backdrop-blur-md border-b border-zbeach-gold/10 px-4 lg:px-8 py-3 flex items-center justify-between">
          <button onClick={() => setOpen(!open)} className="lg:hidden w-9 h-9 rounded-lg bg-zbeach-bg flex items-center justify-center" data-testid="sidebar-toggle">
            <i className="fa-solid fa-bars" />
          </button>
          <div className="font-serif text-lg text-zbeach-dark">Yönetim Paneli</div>
          <a href="/menu" target="_blank" rel="noreferrer" className="px-3 py-1.5 rounded-full bg-zbeach-gold/10 text-zbeach-gold text-xs font-medium hover:bg-zbeach-gold/20" data-testid="view-menu-btn">
            <i className="fa-solid fa-eye mr-1" /> Menüyü Gör
          </a>
        </header>
        <main className="flex-1 p-4 lg:p-8 max-w-7xl w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
